export default{
    allStores:[],
    masterStore:[],
    subStores:[],
    selectedStore:[],
    reservedClients: [],

}